// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer_social-module__icon--2Em9J{height:20px}\n", ""]);
// Exports
exports.locals = {
	"icon": "footer_social-module__icon--2Em9J"
};
module.exports = exports;
